import React from 'react';
import classnames from 'classnames';
import ColumnAligner from '@intelligence/v3/components/TableComponents/ColumnAligner';
import { isEmpty } from '@intelligence/v3/utils/common';

import type { TableColumn } from 'tea-component';
import type { IColumnBaseOption } from './utils';

// Sequence Column构建器自定义配置
interface ISequenceColumnBuilderOptionCore<T = IRecord> {
  // 列单元格的className
  className?: string;
  // 获取序号（通常用于自定义序号），返回为为NaN时视为无效数据，展示-
  getSequence?: (index: number, cvm: T, rowKey: string, column: TableColumn<T>, columnIndex: number) => number;
}

type ISequenceColumnBuilderOption<T> = Partial<TableColumn<T>> &
IColumnBaseOption &
ISequenceColumnBuilderOptionCore<T>;

/**
 * Sequence Column构建器
 * @param sequenceColumnBuilderOption sequenceColumn构建器配置
 * @param sequenceColumnBuilderOption.className 列单元格的className
 */
const SequenceColumnBuilder = <T extends IRecord = IRecord>(
  sequenceColumnBuilderOption: ISequenceColumnBuilderOption<T>,
): TableColumn<T> => {
  const {
    key = 'sequence',
    className,
    align = 'left',
    width = 80,
    header = '#',
    getSequence,
    ...restOption
  } = sequenceColumnBuilderOption || {};

  return {
    ...restOption,
    key,
    align,
    width,
    header: (
      <ColumnAligner align={align} width="100%">
        {/* @ts-ignore */}
        <div className={classnames('dbi-common-column-sequence', className)}>{header}</div>
      </ColumnAligner>
    ),
    render: (cvm, rowKey, recordIndex, ...args) => {
      const sequence = getSequence?.(recordIndex, cvm, rowKey, ...args) ?? recordIndex + 1;
      const sequenceFormatted = isEmpty(sequence) ? '-' : sequence;
      return (
        <ColumnAligner align={align} width="100%">
          <div className={classnames('dbi-common-column-sequence', className)}>{sequenceFormatted}</div>
        </ColumnAligner>
      );
    },
  };
};

export default SequenceColumnBuilder;
